import { ApiEnum } from '../enums';

import { ApiError, ErrorMessage, ErrorsMessages } from '../models';

import { compileMessage } from './messages.utils';

export class ErrorsUtils {

  public static decodeErrorMessage(errorResponse, api: ApiEnum, errorsMessages: ErrorsMessages): ErrorMessage {
    const error = ErrorsUtils.decodeErrorResponse(errorResponse, api);
    const errorMessage = errorsMessages[error.status];
    if (!!errorMessage) {
      return {
        title: errorMessage.title,
        message: ((error.status === 400) ? (error.message || errorMessage.message) : errorMessage.message)
      };
    }
    return {
      title: compileMessage(errorsMessages.default.title, { code: (error.status || '').toString() }).trim(),
      message: (error.message || errorsMessages.default.message)
    };
  }

  public static decodeErrorResponse(errorResponse, api: ApiEnum): ApiError {
    return {
      [ApiEnum.AUTH]: ErrorsUtils.decodeAuthErrorResponse,
      [ApiEnum.USERS]: ErrorsUtils.decodeUsersErrorResponse,
      [ApiEnum.STATS]: ErrorsUtils.decodeStatsErrorResponse,
      [ApiEnum.PLAY]: ErrorsUtils.decodePlayErrorResponse,
      [ApiEnum.INDEX]: ErrorsUtils.decodeIndexErrorResponse,
      [ApiEnum.SEARCH]: ErrorsUtils.decodeSearchErrorResponse
    }[api](errorResponse);
  }

  private static decodeAuthErrorResponse(errorResponse): ApiError {
    return {
      status: errorResponse.status
    };
  }

  private static decodeUsersErrorResponse(errorResponse): ApiError {
    return {
      status: errorResponse.status
    };
  }

  private static decodeStatsErrorResponse(errorResponse): ApiError {
    return {
      status: errorResponse.status,
      message: errorResponse.message
    };
  }

  private static decodePlayErrorResponse(errorResponse): ApiError {
    return {
      status: errorResponse.status,
      message: errorResponse.message,
      details: errorResponse.details
    };
  }

  private static decodeIndexErrorResponse(errorResponse): ApiError {
    return {
      status: errorResponse.status
    };
  }

  private static decodeSearchErrorResponse(errorResponse): ApiError {
    return {
      status: errorResponse.status,
      message: errorResponse.message
    };
  }

}
